<ng-container>
	<div *ngIf="root" class="layout-menuitem-root-text">
		{{ item.translate ? (item.label | translate) : item.label }}
	</div>
	<a
		[attr.href]="item.url"
		(click)="itemClick($event)"
		*ngIf="!item.routerLink || item.items"
		(mouseenter)="onMouseEnter()"
		(keydown.enter)="itemClick($event)"
		[attr.target]="item.target"
		[attr.tabindex]="0"
		[ngClass]="item.class"
		[pTooltip]="item.label"
		[tooltipDisabled]="active || !(root && appMain.isSlim() && !appMain.isMobile())"
		tooltipStyleClass="layout-tooltip"
		pRipple>
		<i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
		<span class="layout-menuitem-text">{{ item.translate ? (item.label | translate) : item.label }}</span>
		<i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
	</a>
	<a
		(click)="itemClick($event)"
		(mouseenter)="onMouseEnter()"
		*ngIf="item.routerLink && !item.items"
		[routerLink]="item.disabled ? null : item.routerLink"
		routerLinkActive="active-menuitem-routerlink"
		[routerLinkActiveOptions]="{ exact: true }"
		[attr.target]="item.target"
		[attr.tabindex]="0"
		[ngClass]="item.class"
		[pTooltip]="item.label"
		[tooltipDisabled]="active || !(root && appMain.isSlim() && !appMain.isMobile())"
		tooltipStyleClass="layout-tooltip"
		pRipple>
		<i [ngClass]="item.icon" class="layout-menuitem-icon"></i>
		<span class="layout-menuitem-text">{{ item.translate ? (item.label | translate) : item.label }}</span>
		<i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
	</a>
	<ul *ngIf="item.items" role="menu" [@children]="root ? 'visible' : active ? 'visibleAnimated' : 'hiddenAnimated'">
		<ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
			<li app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child.badgeClass"></li>
		</ng-template>
	</ul>
</ng-container>
